import { createSelector } from '@reduxjs/toolkit';

import { notNullish } from '@paragon/utilities';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getRelativeMemberGeometriesForActiveComponentDesign = createSelector(
  (state: RootState) => getActiveComponentDesign(state) && getActiveComponentDesign(state)!.component.members,
  (members) => members && members.map((member) => member.relativeGeometry).filter(notNullish),
);

export const getRelativeBearingGeometriesForActiveComponentDesign = createSelector(
  (state: RootState) => getActiveComponentDesign(state) && getActiveComponentDesign(state)!.component.bearings,
  (bearings) => bearings && bearings.map((member) => member.relativeGeometry).filter(notNullish),
);
